<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <div class="tercero-table-block mt-4" v-if="tipoTerceros?.length > 0">
            <CorporateDataTable
                :items="tipoTerceros"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                @row-clicked="(item) => editTipoTercero(item.id)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="createTipoTercero()">
                        {{ labels.addTipoTercero }}
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modalCrear="showTipoTercero" @creado="actualizarTabla" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showEditTipoTercero" :infoEdit="dataTipoTercero" @actualizado="actualizarTabla" @eliminado="actualizarTabla" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import TipoTerceros from '../../../services/TipoTerceros' 
import CorporateDataTable from '../../utils/CorporateDataTable.vue'
import Crear from './Crear.vue' 
import Editar from './Editar.vue' 
export default {
    name:'TipoTerceros',
    components:{Crear,Editar,CorporateDataTable},
    data: () => ({
        tipoTerceros : [],
        showTipoTercero : false,
        showEditTipoTercero : false,
        dataTipoTercero : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'tipo_tercero', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Tipo terceros",
                    codigo : "Código",
                    descripcion : "Descripción",
                    noRow : "No hay registros",
                    addTipoTercero : "Añadir tipo tercero",
                    filterCodigo : "Filtrar código...",
                    filterDescripcion : "Filtrar descripción",
                }
            }else{
                return {
                    title: "Tipo terceros",
                    codigo : "Code",
                    descripcion : "Description",
                    noRow : "There are not records",
                    addTipoTercero : "Add third type",
                    filterCodigo : "Filter code...",
                    filterDescripcion : "Filter description",
                }
            }
        },
        allFields(){
            return [
                { key: 'tipo_tercero', label: this.labels.codigo, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-center', tdClass: 'text-center' }
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'tipo_tercero', type: 'text', placeholder: this.labels.filterCodigo },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion }
            ]
        },
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        createTipoTercero(){
            this.showTipoTercero = true 
        },
        editTipoTercero(id){
            // console.log(id); 
            TipoTerceros.getTipoTerceroById(id) 
            .then((res) => { 
                // console.log(res.data.tipoTercero) 
                this.dataTipoTercero = res.data.tipoTercero 
                this.showEditTipoTercero = true 
            })
            .catch((err) => { console.log(err)}) 
        },
        closeModal(valor){
            this.showTipoTercero = valor 
            this.showEditTipoTercero = valor 
        },
        actualizarTabla(){
            TipoTerceros.getAllTipoTerceros() 
            .then((res) => {
                this.tipoTerceros = res.data.listTipoTerceros 
            })
            .catch((err) => { console.log(err)})
        }
    },
    mounted(){
        TipoTerceros.getAllTipoTerceros() 
        .then((res) => { 
            // console.log(res.data.listTipoTerceros) 
            this.tipoTerceros = res.data.listTipoTerceros 
        })
        .catch((err) => { console.log(err)}) 
    }
}
</script>

<style>

</style>
